<script>
import Vue from 'vue';
import OembedInput from './oembed_input';
import OembedVideo from './oembed_video';

export default Vue.component('oembed-preview', {
    components: {
        OembedInput,
        OembedVideo
    },

    props: {
        type: {
            type: [String, Boolean],
            default: 'input'
        },

        value: {
            type: String,
            default: null
        },

        name: {
            type: String,
            default: null
        },

        placeholder: {
            type: String,
            default: null
        },

        inputClass: {
            type: String,
            default: null
        },

        baseClass: {
            type: String,
            default: 'embed-responsive embed-responsive-16by9 m-t-15'
        },

        showInput: {
            type: Boolean,
            default: true
        }
    }
});
</script>

<template>
    <div>
        <oembed-input
            :type="type"
            :name="name"
            :placeholder="placeholder"
            :input-class="inputClass"
            :value="value"
            :visible="showInput"
            @loaded="$emit('loaded', $event)"
            @input="$emit('input', $event)">
        </oembed-input>

        <oembed-video
            :base-class="baseClass">
        </oembed-video>
    </div>
</template>